import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./AuthContext";
import Whyglobal from "../Components/Whyglobal";
import BuyerSide from "./BuyerSidebuyer";
import "./OnionBuy.css"; // CSS styling for the Aapalam buyers' section

const AlveBuyer = [
  {
    name: "Bharat Purohit",
    email: "Bharatpurohit@gmail.com",
    mobileNumber: "9321557141",
    location: "Mumbai",
    date: "05-04-2025",
    lookingFor: "Interested in sourcing bulk SS fitting items.",
    productOrService: "SS Fitting Item",
    quantity: "700",
    unit: "pieces",
    _id: "hardware_buyer_001",
  },
  {
    name: "Lalit Agrawal",
    email: "lalitagarwalknw@gmail.com",
    mobileNumber: "8770666465",
    location: "Khandwa, Madhya Pradesh",
    date: "05-04-2025",
    lookingFor: "Bulk hardware product requirement.",
    productOrService: "Hardware Products",
    quantity: "400",
    unit: "pieces",
    _id: "hardware_buyer_002",
  },
  {
    name: "Ramanji Sharma",
    email: "",
    mobileNumber: "8141086952",
    location: "Surat",
    date: "05-04-2025",
    lookingFor: "Looking to buy door handles in bulk.",
    productOrService: "Door Handles",
    quantity: "900",
    unit: "pieces",
    _id: "hardware_buyer_003",
  },
  {
    name: "Prabhakar",
    email: "",
    mobileNumber: "9948120550",
    location: "Telangana",
    date: "05-04-2025",
    lookingFor: "Bulk purchase of door handles needed.",
    productOrService: "Door Handles",
    quantity: "500",
    unit: "pieces",
    _id: "hardware_buyer_004",
  },
  {
    name: "Ganpat Modi",
    email: "",
    mobileNumber: "9594572877",
    location: "Ahmedabad",
    date: "05-04-2025",
    lookingFor: "Looking for bulk door handles, SS support & socket.",
    productOrService: "Door Handles, SS Support, Conceal Socket",
    quantity: "200",
    unit: "pieces",
    _id: "hardware_buyer_005",
  },
  {
    name: "Kutub Jodiyawala",
    email: "",
    mobileNumber: "9924760542",
    location: "India",
    date: "05-04-2025",
    lookingFor: "Bulk purchase of hardware products.",
    productOrService: "Hardware Products",
    quantity: "450",
    unit: "pieces",
    _id: "hardware_buyer_006",
  },
  {
    name: "Chandan Saini",
    email: "",
    mobileNumber: "8619339141",
    location: "Chhindwara, Rajasthan",
    date: "05-04-2025",
    lookingFor: "Interested in purchasing door handles in bulk.",
    productOrService: "Door Handles",
    quantity: "300",
    unit: "pieces",
    _id: "hardware_buyer_007",
  },
  {
    name: "Karan Patel",
    email: "",
    mobileNumber: "9586176422",
    location: "Vadodara",
    date: "05-04-2025",
    lookingFor: "Looking for retail quantity of door handles.",
    productOrService: "Door Handles",
    quantity: "490",
    unit: "pieces",
    _id: "hardware_buyer_008",
  },
  {
    name: "Darshan Sharma",
    email: "",
    mobileNumber: "9466643299",
    location: "Haryana",
    date: "05-04-2025",
    lookingFor: "Bulk requirement of hardware items.",
    productOrService: "Hardware Products",
    quantity: "12000",
    unit: "pieces",
    _id: "hardware_buyer_009",
  },
  {
    name: "Khurshid Ahmad",
    email: "",
    mobileNumber: "8859508760",
    location: "Auraiya, UP",
    date: "05-04-2025",
    lookingFor: "Seeking all types of hardware products in bulk.",
    productOrService: "All Hardware Products",
    quantity: "4000",
    unit: "pieces",
    _id: "hardware_buyer_010",
  },
  {
    name: "Sandeep Tyagi",
    email: "",
    mobileNumber: "9871030984",
    location: "Sita Ram, Delhi",
    date: "05-04-2025",
    lookingFor: "Door handles needed in large quantity for trading.",
    productOrService: "Door Handles",
    quantity: "5000",
    unit: "pieces",
    _id: "hardware_buyer_011",
  },
  {
    name: "Miraj Hussain",
    email: "",
    mobileNumber: "9078295037",
    location: "Puri, Odisha",
    date: "05-04-2025",
    lookingFor: "Inquiring about bulk supply of door handles.",
    productOrService: "Door Handles",
    quantity: "7000",
    unit: "pieces",
    _id: "hardware_buyer_012",
  },
  {
    name: "Kuldeep Mehra",
    email: "",
    mobileNumber: "8700931735",
    location: "Delhi",
    date: "05-04-2025",
    lookingFor: "Bulk demand for hardware items.",
    productOrService: "Hardware Products",
    quantity: "9000",
    unit: "pieces",
    _id: "hardware_buyer_013",
  },
  {
    name: "Irshad Ahmad",
    email: "",
    mobileNumber: "9997825347",
    location: "UP",
    date: "05-04-2025",
    lookingFor: "Wholesale purchase of door handles.",
    productOrService: "Door Handles",
    quantity: "400",
    unit: "pieces",
    _id: "hardware_buyer_014",
  },
  {
    name: "Sanjeev Kumar",
    email: "",
    mobileNumber: "9988737235",
    location: "Punjab",
    date: "05-04-2025",
    lookingFor: "Interested in buying door handles in quantity.",
    productOrService: "Door Handles",
    quantity: "900",
    unit: "pieces",
    _id: "hardware_buyer_015",
  },
  {
    name: "Rinku Saini",
    email: "",
    mobileNumber: "8955059465",
    location: "Rajasthan",
    date: "05-04-2025",
    lookingFor: "Hardware items needed in bulk.",
    productOrService: "Hardware Products",
    quantity: "600",
    unit: "pieces",
    _id: "hardware_buyer_016",
  },
  {
    name: "Divyesh Markana",
    email: "",
    mobileNumber: "9714420064",
    location: "Gujarat",
    date: "05-04-2025",
    lookingFor: "Looking for suppliers of door handles in bulk.",
    productOrService: "Door Handles",
    quantity: "12000",
    unit: "pieces",
    _id: "hardware_buyer_017",
  },
];

const HardwareBuyers = () => {
  const { userId } = useAuth();
  const [userIsPremium, setUserIsPremium] = useState(false);
  const [shownNumbers, setShownNumbers] = useState([]);
  const [leadsViewed, setLeadsViewed] = useState(0);

  useEffect(() => {
    if (!userId) return;

    const storedViewedLeads =
      JSON.parse(localStorage.getItem(`aapalamViewedLeads_${userId}`)) || [];
    setShownNumbers(storedViewedLeads);

    fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/getUserWithPremiumStatus/${userId}`
    )
      .then((response) => response.json())
      .then((data) => {
        setUserIsPremium(data.isPremium);
        setLeadsViewed(data.leadsViewed);
      })
      .catch((error) => {
        console.error("Error fetching user information:", error);
      });
  }, [userId]);

  const toggleNumber = async (index) => {
    if (!userIsPremium) return;

    if (leadsViewed >= 25) {
      alert("You have reached the limit of 25 leads viewed per month.");
      return;
    }

    if (shownNumbers.includes(index)) return;

    const updatedShownNumbers = [...shownNumbers, index];
    setShownNumbers(updatedShownNumbers);

    localStorage.setItem(
      `aapalamViewedLeads_${userId}`,
      JSON.stringify(updatedShownNumbers)
    );

    const buyer = AlveBuyer[index];

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/incrementLeadsViewed/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            buyerName: buyer.name,
            mobileNo: buyer.mobileNumber,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setLeadsViewed(data.leadsViewed);
      } else {
        const errorData = await response.json();
        console.error("Error incrementing leads viewed:", errorData.error);
      }
    } catch (error) {
      console.error("Error incrementing leads viewed:", error.message);
    }
  };

  return (
    <>
      <div className="container">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to={"/"}>Home</Link>
          </li>
          <li className="breadcrumb-item active">Aapalam Buyers</li>
        </ol>
      </div>
      <div className="containersx">
        <div style={{ width: "200px", padding: "10px" }} className="browsers">
          <h3>Browse by State</h3>
          <ul className="flt-list cust-scroll" id="state-lists">
            <li>
              <Link to="#">All India</Link>
            </li>
            <li>
              <Link to="#">Maharashtra</Link>
            </li>
            <li>
              <Link to="#">Tamil Nadu</Link>
            </li>
            <li>
              <Link to="#">Delhi</Link>
            </li>
            <li>
              <Link to="#">Gujarat</Link>
            </li>
          </ul>
          <ul className="flt-list cust-scroll">
            <h3>All Varieties</h3>
            <ul className="flt-list cust-scroll">
              <li>
                <Link to="#">Hinges</Link>
              </li>
              <li>
                <Link to="#">Door Handles</Link>
              </li>
              <li>
                <Link to="#">Nails & Screws</Link>
              </li>
              <li>
                <Link to="#">Locks & Latches</Link>
              </li>
              <li>
                <Link to="#">Power Tools</Link>
              </li>
            </ul>
          </ul>
        </div>
        <div className="buyers">
          {AlveBuyer.map((buyer, index) => (
            <div key={index} className="buyer-card">
              <h2 style={{ color: "blue" }}>{buyer.lookingFor}</h2>
              <p>
                <strong>Buyer Name:</strong> {buyer.name}
              </p>
              <p>
                <strong>Quantity:</strong> {buyer.quantity} {buyer.unit}
              </p>
              <p>
                <strong>Location </strong> {buyer.location}
              </p>

              <p>
                <strong>Date:</strong> {buyer.date}
              </p>
              <p>
                <strong>Mobile No.:</strong>{" "}
                {userIsPremium
                  ? shownNumbers.includes(index)
                    ? buyer.mobileNumber
                    : "********"
                  : "********"}
              </p>
              <button
                className="detail-btn"
                onClick={() => toggleNumber(index)}
                disabled={!userIsPremium}
              >
                <div className="btns-imp">
                  <Link to={"/login"}>
                    <button className="detailing-btn">View More</button>
                  </Link>
                  <Link to={"/register-Company"}>
                    <button className="regis-btn">Register Now</button>
                  </Link>
                </div>
              </button>
            </div>
          ))}
        </div>
        <BuyerSide />
      </div>
      <Whyglobal />
    </>
  );
};

export default HardwareBuyers;
